import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../common/Icon'

// Import styled components
import {
  LinkMore,
  ContentMore
} from './StatitisResponsive'
import { px2Rem } from '../../../themes/Mixins';

// Defined component StatitisMore
const StatitisMore = ({ text, href }) => {
  return (
    <LinkMore href={href} target='_blank' rel='noopener'>
      <ContentMore>
        {text}
      </ContentMore>
      <Icon
        icon='rightArrow'
        customStyle={{
          margin: '0',
          width: px2Rem(18),
          height: px2Rem(12)
        }}
      />
    </LinkMore>
  )
}

StatitisMore.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string
}

StatitisMore.defaultProps = {
  href: '',
  text: ''
}

export default StatitisMore



// WEBPACK FOOTER //
// ./src/components/sections/statitis/StatitisMore.js